// @flow
import { handleResponseOld, makePost } from './helpers';

type FetchCatalogAdParams = {
    categoryIds: any,
    deployment: string,
    keywords: any,
    pageName: any,
};

export default {
    fetchCatalogAd: ({ categoryIds, deployment, keywords, pageName }: FetchCatalogAdParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ deployment, path: '<ITEM-API>spa/ads/page' });
            request.send({ categoryIds, keywords, pageName });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
